import React from "react";
import { useTranslation } from "react-i18next";

interface ColorModeButtonProps {
  active: boolean;
  disabled?: boolean;
  onClick: () => void;
}

// Toggles a report between the standard monochrome table and color mode
// (dark background, colored status badges, all rows in one scrolling list).
export const ColorModeButton = ({
  active,
  disabled = false,
  onClick,
}: ColorModeButtonProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "reports" });
  const [showText, setShowText] = React.useState(false);
  const label = active ? t("color_mode.turn_off") : t("color_mode.turn_on");

  return (
    <button
      type="button"
      aria-pressed={active}
      aria-label={label}
      className={`relative flex items-center justify-center hover:flex-row ${showText ? "rounded-e-lg z-listing-table-header-icons-showtext" : "rounded-lg z-listing-table-header-icons"} w-10 py-2 ${active ? "bg-slate-800 text-amber-300" : "bg-accent-blue-pale text-accent-blue-dark"} ${disabled ? "opacity-50 grayscale pointer-events-none touch-none" : ""}`}
      onClick={onClick}
      onMouseEnter={() => setShowText(true)}
      onMouseLeave={() => setShowText(false)}
    >
      {showText && (
        <span
          className={`absolute h-full right-full top-0 text-sm font-semibold rounded-s-lg ps-4 flex items-center leading-6 whitespace-nowrap ${active ? "bg-slate-800 text-white" : "bg-accent-blue-pale text-black"}`}
        >
          {label}
        </span>
      )}
      {/* palette icon */}
      <svg
        viewBox="0 0 24 24"
        className="size-6"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
        aria-hidden="true"
      >
        <path d="M12 3a9 9 0 1 0 0 18c1.1 0 1.8-.9 1.8-1.9 0-.5-.2-.9-.5-1.2-.3-.3-.5-.7-.5-1.2 0-1 .8-1.7 1.8-1.7H16a5 5 0 0 0 5-5C21 6.4 17 3 12 3Z" />
        <circle cx="7.5" cy="11" r="1.3" fill="currentColor" />
        <circle cx="10" cy="7" r="1.3" fill="currentColor" />
        <circle cx="14.5" cy="7" r="1.3" fill="currentColor" />
        <circle cx="17" cy="11" r="1.3" fill="currentColor" />
      </svg>
    </button>
  );
};

export default ColorModeButton;
